import { render, staticRenderFns } from "./Published.vue?vue&type=template&id=22d539a8&scoped=true"
import script from "./Published.vue?vue&type=script&lang=js"
export * from "./Published.vue?vue&type=script&lang=js"
import style0 from "./Published.vue?vue&type=style&index=0&id=22d539a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d539a8",
  null
  
)

export default component.exports